import { ANALYSIS_VERSION } from '../analysis/config/analysisVersion'
import { LAP_PROCESSING_VERSION } from '../domain/lap/lapProcessingVersion'
import { LAPS_FORMAT_VERSION } from './lapsFormat/lapsCodec'

export const PROCESSED_SESSION_VERSION_KEY = `l${LAP_PROCESSING_VERSION}-a${ANALYSIS_VERSION}-f${LAPS_FORMAT_VERSION}`
